import { createReducer } from "@reduxjs/toolkit";
import { NavPoint, setNavPoint } from "@redux/legacy-actions/navPoints";

export default createReducer<NavPoint>(null, builder => {
  builder.addCase(setNavPoint, (state, action) => {
    return { ...action.payload };
  });
});
